import { useCallback, useEffect, useState } from 'react';
const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
export function storedValue(org) {
    var _a;
    const value = (_a = org === null || org === void 0 ? void 0 : org.options) === null || _a === void 0 ? void 0 : _a.default_quicksight_dashboard;
    return typeof value === 'string' ? value : '';
}
export function useQuicksightDashboardField(org) {
    const [value, setValue] = useState(() => storedValue(org));
    const reset = useCallback(() => {
        setValue(storedValue(org));
    }, [org]);
    useEffect(() => {
        const nextValue = storedValue(org);
        if (value !== nextValue) {
            setValue(nextValue);
        }
    }, [org]);
    const trimmedValue = value.trim();
    const error = trimmedValue && !UUID_REGEX.test(trimmedValue)
        ? 'Must be a valid UUID'
        : null;
    const toOptionsPatch = useCallback(() => {
        if (error) {
            return {};
        }
        return { default_quicksight_dashboard: trimmedValue || null };
    }, [error, trimmedValue]);
    return { value, setValue, error, reset, toOptionsPatch };
}
